module.exports = __webpack_public_path__ + "static/media/white_cherry_jam.22059906.png";